/* Paintly Kits: change a kit that is already in the cart (8 Oct 2026).
   Reached from the cart's "Change size or options" link, and from the kit's picture and name there:
     AI kits:     /products/<ai kit>?variant=<id>&design=<picture>&edit=<line key>&kit=<kit id>
                  (or &remix=<picture> after "Change something in this design" or "Edit this design")
     custom kits: /products/<custom kit>?variant=<id>&photo=<photo>&edit=<line key>&kit=<kit id>
   A kit is its product, its variant and all of its notes (every property with a value). The "every 3rd kit free" deal
   splits one kit into several lines with the same notes, which count as one kit; a kit with other notes is a different
   kit and is never touched. Round 12 uses a canonical JSON array of raw variant and sorted raw notes, with a versioned
   digest for cart links. The links are hydrated from the Ajax cart because Liquid sanitizes property names. Legacy
   links may resolve by an exact line key but their ambiguous kit IDs are never used as a fallback.
   The page opens with the kit as it is in the cart. "Add to cart" becomes "Update my kit". One press is one tracked
   update: the theme adds the new version as usual; when that add comes back successful and the new version is found in
   the cart by all of its notes, the old kit's lines are taken out, and the update is finished only when the old kit is
   confirmed gone (the page then edits the new version). Pending updates are saved before sending. Ambiguous replies
   and reloads reconcile the exact quantity increase against the saved cart baseline before removal. Until resolved,
   Update only checks that operation again. An initial cart-read failure keeps submissions guarded with a retry note.
   Loaded by the carts, AI kit forms and photo uploader. Non-edit pages only hydrate cart links.
   Rounds 3 to 9: the kit's own options on the AI forms; the note above the button's row; a link to another product's kit
   is never used; the address keeps the kit; quantities changed in the drawer are kept.
   Round 10 (Codex review): removal confirmed before success, with a clear partial state; an add that comes back late
   is still settled; kits with different notes are kept apart; a kit taken out while the page is open turns the page
   back into a plainly labelled normal page.
   Round 11 (Codex review of round 10): an older link opens the kit as it is now (its current picture and options); a
   partial update survives a reload; a second press while an add is still on its way is held; the new version is found
   by all of its notes; remembered changes expire after a day when read; no guessing: a link whose kit is gone opens
   the normal page and says so. */
(function () {
  'use strict';
  if (window.__pkCartEdit) return;
  window.__pkCartEdit = 1;

  var q = location.search;
  function param(k) {
    var m = new RegExp('[?&]' + k + '=([^&#]*)').exec(q);
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return ''; }
  }
  var KEY = param('edit');
  var KITID = param('kit');
  var PICP = param('remix') ? 'remix' : param('design') ? 'design' : 'photo';   /* how the link names the picture */
  var AI = PICP !== 'photo';
  var PIC = param('design') || param('remix') || param('photo');
  var PROP = AI ? '_AI Image URL' : '_Your photo';
  /* this page's product */
  var HANDLE = ((location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '').toLowerCase();

  /* Round 12: Liquid's property names are lossy. Add stable IDs to cart links from the raw Ajax cart instead.
     Until this completes a link has its exact line key only; a missing key fails closed, never guesses. */
  ready(initCartLinks);
  if (!KEY || !PIC) return;

  var OLD = null;          /* one line of the kit being changed */
  var OLDSIG = '';         /* that kit: variant and all its notes */
  var OLDQTY = 1;          /* how many of it the cart holds, over all its lines */
  var MODE = 'loading';
  var OP = null;           /* the update under way: { v, pic, want, t, seen, newSig, newKey, olds } */
  var touched = false, ADD_LABEL = '', madeQty = null, QTY0 = null, NOTE = null, BTN = null, refreshTimer = null;
  var drawerHeld = false, drawerStale = false, drawerWait = false, replacedSections = [];
  var ONNEW = false;       /* this page was opened for the new kit of an update that is still partial */
  var initializing = false, releaseSubmit = false, addressHook = false, labelingButton = null;

  function props(i) { return (i && i.properties) || {}; }
  function picOf(i) { return props(i)[PROP] || ''; }
  function sameProduct(i) { return !!HANDLE && String((i && i.handle) || '').toLowerCase() === HANDLE; }
  /* one kit: its variant and every note on it that has a value, in a fixed order */
  function sigOf(i) {
    var p = props(i), ks = Object.keys(p).sort(), pairs = [], v;
    for (var j = 0; j < ks.length; j++) {
      if (ks[j] === '_PK Checkout Image' || ks[j] === '_PK Checkout Source') continue;
      v = p[ks[j]];
      v = v == null ? '' : String(v);
      if (v !== '') pairs.push([ks[j], v]);
    }
    return JSON.stringify([String(i && i.variant_id), pairs]);
  }
  function idOf(sig) { return '2_' + md5(sig); }
  function kitOf(i) { return idOf(sigOf(i)); }
  function linesOf(c, sig) {
    var out = [];
    for (var i = 0; c && sig && i < c.items.length; i++) if (sameProduct(c.items[i]) && sigOf(c.items[i]) === sig) out.push(c.items[i]);
    return out;
  }
  function linesByKit(c, kit) {
    var out = [];
    for (var i = 0; c && kit && i < c.items.length; i++) if (sameProduct(c.items[i]) && kitOf(c.items[i]) === kit) out.push(c.items[i]);
    return out;
  }
  function linesById(c, id) {
    var out = [];
    for (var i = 0; c && id && i < c.items.length; i++) if (sameProduct(c.items[i]) && idOf(sigOf(c.items[i])) === id) out.push(c.items[i]);
    return out;
  }
  function hasKey(c, k) { for (var i = 0; c && i < c.items.length; i++) if (c.items[i].key === k) return true; return false; }
  function sumQty(ls) { var n = 0; for (var i = 0; i < ls.length; i++) n += ls[i].quantity; return n; }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function initCartLinks() {
    var pending = false, timer;
    function scan() {
      if (pending) return;
      var links = Array.prototype.filter.call(document.querySelectorAll('a[data-pk-cart-edit-link]'), function (a) {
        return a.getAttribute('data-pk-kit-ready') !== a.getAttribute('href');
      });
      if (!links.length) return;
      pending = true;
      getCart().then(function (c) {
        links.forEach(function (a) {
          var u, key, item, handle;
          try { u = new URL(a.href, location.href); } catch (e) { return; }
          if (u.origin !== location.origin) return;
          key = u.searchParams.get('edit');
          handle = ((u.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '').toLowerCase();
          for (var j = 0; j < c.items.length; j++) if (c.items[j].key === key && c.items[j].handle === handle) item = c.items[j];
          u.searchParams.delete('kit');
          if (item) u.searchParams.set('kit', kitOf(item));
          var href = u.pathname + u.search + u.hash;
          a.setAttribute('data-pk-kit-ready', href);
          a.setAttribute('href', href);
        });
      }).catch(function () {
        /* Exact-key links remain usable. Retry on the next cart interaction, not a polling loop. */
        links.forEach(function (a) { a.setAttribute('data-pk-kit-ready', a.getAttribute('href')); });
      }).then(function () { pending = false; schedule(); });
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(scan, 80); }
    scan();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    document.addEventListener('pointerdown', function (e) {
      var a = e.target.closest && e.target.closest('a[data-pk-cart-edit-link]');
      if (a && !/2_[a-f0-9]{32}/.test(a.getAttribute('href') || '')) { a.removeAttribute('data-pk-kit-ready'); scan(); }
    }, true);
  }
  function theForm() {
    var f = document.getElementById('ai-product-form');
    if (f) return f;
    var fs = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < fs.length; i++) {
      var id = fs[i].getAttribute('id') || '';
      if (id.indexOf('product-form-') === 0 && id.indexOf('installment') === -1) return fs[i];
    }
    return null;
  }

  /* md5 of the text's UTF-8 bytes, as Liquid's md5 filter makes it (RFC 1321) */
  function md5(str) {
    var b = [], i, j, s = String(str);
    if (typeof TextEncoder !== 'undefined') { var u8 = new TextEncoder().encode(s); for (i = 0; i < u8.length; i++) b.push(u8[i]); }
    else { var x = unescape(encodeURIComponent(s)); for (i = 0; i < x.length; i++) b.push(x.charCodeAt(i) & 255); }
    var n = b.length;
    b.push(0x80);
    while (b.length % 64 !== 56) b.push(0);
    var bits = n * 8;
    for (i = 0; i < 8; i++) { b.push(bits % 256); bits = Math.floor(bits / 256); }
    var S = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21], K = [];
    for (i = 0; i < 64; i++) K[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 4294967296) | 0;
    var a0 = 0x67452301, b0 = 0xefcdab89 | 0, c0 = 0x98badcfe | 0, d0 = 0x10325476;
    for (var off = 0; off < b.length; off += 64) {
      var M = [];
      for (i = 0; i < 16; i++) M[i] = b[off + i * 4] | (b[off + i * 4 + 1] << 8) | (b[off + i * 4 + 2] << 16) | (b[off + i * 4 + 3] << 24);
      var A = a0, B = b0, C = c0, D = d0, F, g, t;
      for (i = 0; i < 64; i++) {
        if (i < 16) { F = (B & C) | (~B & D); g = i; }
        else if (i < 32) { F = (D & B) | (~D & C); g = (5 * i + 1) % 16; }
        else if (i < 48) { F = B ^ C ^ D; g = (3 * i + 5) % 16; }
        else { F = C ^ (B | ~D); g = (7 * i) % 16; }
        t = (F + A + K[i] + M[g]) | 0;
        var r = S[(i >> 4) * 4 + (i % 4)];
        A = D; D = C; C = B;
        B = (B + ((t << r) | (t >>> (32 - r)))) | 0;
      }
      a0 = (a0 + A) | 0; b0 = (b0 + B) | 0; c0 = (c0 + C) | 0; d0 = (d0 + D) | 0;
    }
    var out = '', w = [a0, b0, c0, d0];
    for (i = 0; i < 4; i++) for (j = 0; j < 4; j++) { var h = ((w[i] >>> (j * 8)) & 255).toString(16); out += h.length < 2 ? '0' + h : h; }
    return out;
  }

  /* What this browser remembers, for a day, in one place (read again, and checked for age, every time):
       "<old line key>": { to: <new line key>, t }   an update here replaced that line (older links follow it)
       "p:<old kit id>": { n: <new kit id>, t }       an update here added the new kit but could not take the old one out
     Kept to the newest 40. */
  var MEM = 'pkCartEditMoved', DAY = 864e5;
  function fresh(e) { return !!e && typeof e === 'object' && typeof e.t === 'number' && Math.abs(Date.now() - e.t) < DAY; }
  function memory() {
    var m = {}, out = {}, k;
    try { m = JSON.parse(localStorage.getItem(MEM) || '{}'); } catch (e) { m = {}; }
    if (!m || typeof m !== 'object') return out;
    for (k in m) if (Object.prototype.hasOwnProperty.call(m, k) && fresh(m[k])) out[k] = m[k];
    return out;
  }
  function keep(m) {
    try {
      var ks = Object.keys(m).sort(function (a, b) { return Number(b.indexOf('p:') === 0) - Number(a.indexOf('p:') === 0) || m[b].t - m[a].t; });
      for (var i = 40; i < ks.length; i++) delete m[ks[i]];
      var value = JSON.stringify(m);
      localStorage.setItem(MEM, value);
      return localStorage.getItem(MEM) === value;
    } catch (e) { return false; }
  }
  function remember(froms, to, newSig, oldSig) {
    var m = memory(), now = Date.now();
    /* Also advance old aliases whose last physical line disappeared in a discount reallocation. */
    for (var k in m) if (m[k].s === oldSig && m[k].to) { m[k].to = to; m[k].s = newSig; }
    for (var i = 0; i < froms.length; i++) if (froms[i] && froms[i] !== to) m[froms[i]] = { to: to, s: newSig, t: now };
    keep(m);
  }
  function pendingSet(oldId, op) {
    var m = memory();
    m['p:' + oldId] = { n: op.newSig ? idOf(op.newSig) : '', unknown: !op.newSig,
      want: op.want || '', newKey: op.newKey || '', t: Date.now(),
      operation: op.before ? op : null, old: op.before ? OLD : null, handle: HANDLE };
    return keep(m) && !!memory()['p:' + oldId];
  }
  function pendingDrop(oldId) { var m = memory(); if (m['p:' + oldId]) { delete m['p:' + oldId]; keep(m); } }

  /* an older link names a line an update here has since replaced: follow it to the line the kit is on now */
  function follow(c) {
    var m = memory(), k = KEY, n = 0, e, ls;
    while (!hasKey(c, k) && m[k] && m[k].to && n++ < 40) {
      e = m[k]; k = e.to;
      if (!hasKey(c, k) && e.s) {
        ls = linesOf(c, e.s);
        if (ls.length) { KEY = ls[0].key; return true; }
      }
    }
    if (k !== KEY && hasKey(c, k)) { KEY = k; return true; }
    return false;
  }

  /* The kit in the cart: by its line key, which must be on this product (a key from another product's kit does not
     belong here); else, when the deal has re-keyed its lines since the link was made, by its kit id (the same variant
     and the same notes, so the same kit). Nothing else: no guessing by picture or size. */
  function findOld(c) {
    var i, it;
    for (i = 0; i < c.items.length; i++) {
      it = c.items[i];
      if (it.key === KEY) return sameProduct(it) ? it : null;
    }
    var ls = linesByKit(c, KITID);
    if (!ls.length) return null;
    var sig = sigOf(ls[0]);
    for (i = 1; i < ls.length; i++) if (sigOf(ls[i]) !== sig) return null;
    return ls[0];
  }

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  document.addEventListener('submit', function (e) {
    if (e.target !== theForm() || (MODE !== 'loading' && MODE !== 'loaderror')) return;
    stop(e);
    if (MODE === 'loaderror') initialize();
  }, true);
  ready(function () { Promise.resolve().then(initialize); });
  function initialize() {
    if (initializing) return;
    initializing = true;
    MODE = 'loading';
    var form = theForm();
    BTN = form && (form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]'));
    keepAddress(); makeNote(form); watchLabel(); say('loading');
    getCart().then(function (c) {
      var followed = follow(c);
      var found = findOld(c);
      if (!found) {
        var mem = memory();
        for (var k in mem) {
          var entry = mem[k];
          if (k.indexOf('p:') === 0 && entry.handle === HANDLE && entry.old && entry.operation &&
            (k === 'p:' + KITID || entry.operation.olds.indexOf(KEY) !== -1)) { found = entry.old; break; }
        }
      }
      if (!found) return notInCart();           /* not in the cart (or not this page's): the page works as usual, and says so */
      /* an older link, followed to the kit's new version: open the kit as it is now (its picture and options), never the
         picture and options the link was made with */
      if (followed && (picOf(found) !== PIC || String(found.variant_id) !== param('variant'))) return reopen(found);
      OLD = found;
      OLDSIG = sigOf(found);
      OLDQTY = sumQty(linesOf(c, OLDSIG)) || found.quantity || 1;
      KEY = found.key;
      MODE = 'idle';
      addressKey();
      restorePending(c);
      setup();
    }).catch(function () { MODE = 'loaderror'; say('loaderror'); })
      .then(function () { initializing = false; });
  }

  /* load the page again for the kit as it is in the cart now */
  function reopen(k) {
    try {
      var f = theForm(), b = f && f.querySelector('[type="submit"]');
      if (b) b.disabled = true;
      var u = new URL(location.href);
      u.searchParams.delete('design'); u.searchParams.delete('remix'); u.searchParams.delete('photo');
      u.searchParams.set('variant', k.variant_id);
      u.searchParams.set(PICP, picOf(k));
      u.searchParams.set('edit', k.key);
      u.searchParams.set('kit', kitOf(k));
      RS.call(history, history.state, '', u.pathname + u.search + u.hash);
      location.reload();
    } catch (e) {}
  }

  /* a reload while an update here had added the new kit but not yet taken the old one out: back to that state, so
     Update my kit only takes the old one out. Found from either kit's page. */
  function restorePending(c) {
    var m = memory(), me = idOf(OLDSIG), e = m['p:' + me], k, ls;
    if (e) {
      if (e.operation && e.handle === HANDLE) {
        OP = e.operation;
        MODE = 'partial';
        return;
      }
      if (e.unknown) {
        OP = { want: e.want || '', newKey: e.newKey || '', newSig: '', seen: true, olds: [KEY] };
        MODE = 'partial';
        return;
      }
      ls = linesById(c, e.n);
      if (ls.length) {
        OP = { v: ls[0].variant_id, pic: picOf(ls[0]), want: sigOf(ls[0]), t: Date.now(), seen: true, newSig: sigOf(ls[0]), newKey: ls[0].key, olds: [KEY] };
        MODE = 'partial';
        return;
      }
      pendingDrop(me);
    }
    for (k in m) {
      if (k.indexOf('p:') !== 0 || m[k].n !== me) continue;
      ls = linesById(c, k.slice(2));
      if (ls.length) {
        var newSig = OLDSIG;
        OP = m[k].operation || { v: OLD.variant_id, pic: picOf(OLD), want: newSig, t: Date.now(), seen: true, newSig: newSig, newKey: KEY, olds: [ls[0].key] };
        OLD = ls[0];
        OLDSIG = sigOf(ls[0]);
        MODE = 'partial';
        ONNEW = true;
        return;
      }
      pendingDrop(k.slice(2));
    }
  }

  /* the link's kit is not in the cart: a normal page, so the Studio's cart heading goes back to its usual one and the
     address forgets the kit */
  function headingNormal() {
    var h1 = document.querySelector('#paintly-aigen .ag2-hero h1');
    if (h1 && /change\s+your kit/i.test(h1.textContent)) {
      h1.innerHTML = 'Your design is <span class="hl">ready to order.</span>';
      var lede = document.querySelector('#paintly-aigen .ag2-hero .lede');
      if (lede) lede.textContent = 'This is the picture you picked. Choose your size and we will get started.';
    }
  }
  function forgetKit() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('edit');
      u.searchParams.delete('kit');
      RS.call(history, history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function notInCart() {
    forgetKit();
    headingNormal();
    MODE = 'off';
    var form = theForm();
    BTN = form && (form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]'));
    makeNote(form);
    unlabel();
    say('gone');
  }

  /* what the note above the button says, for each state */
  var SAY = {
    updating: 'Updating your kit. Your cart will open when it is ready.',
    refresh: 'Your kit was updated, but we could not refresh the cart preview. Open your cart to check it.',
    loading: 'Checking the kit in your cart. Please wait a moment.',
    loaderror: 'We could not load your cart. No update has been started. Press Update my kit to try loading it again.',
    storage: 'We could not safely save this update in your browser, so no new kit was added. Please try again or change the kit from your cart.',
    preflight: 'We could not check your cart, so no update was sent. Press Update my kit to try again.',
    edit: 'You are changing a kit that is in your cart. It stays as it is until you press Update my kit.',
    failed: 'The new kit was not added. Your original kit has been kept. Please try again.',
    partial: 'Your new kit is in your cart, but the old one is still there too. Press Update my kit to take the old one out, or remove it in your cart.',
    uncertain: 'We could not confirm which kit was added. Please check your cart. This page will not add another kit; pressing Update my kit only checks the previous update again.',
    wait: 'Your last change is still on its way to your cart. Please wait a moment before you press Update my kit again.',
    gone: 'This kit is no longer in your cart, so this page will add it as a new kit.'
  };
  function say(kind) {
    if (!NOTE) return;
    if (drawerHeld && kind === 'edit') kind = 'updating';
    NOTE.textContent = (kind === 'partial' && OP && !OP.newSig) ? SAY.uncertain : SAY[kind];
    NOTE.setAttribute('data-say', kind);
    NOTE.style.background = (kind === 'failed' || kind === 'partial') ? '#FBE8E3' : '#F3ECF7';
  }
  function makeNote(form) {
    if (NOTE || !BTN || !form) return;
    NOTE = document.getElementById('pk-edit-note');
    if (NOTE) return;
    NOTE = document.createElement('p');
    NOTE.id = 'pk-edit-note';
    NOTE.setAttribute('role', 'status');
    NOTE.setAttribute('aria-live', 'polite');
    NOTE.style.cssText = 'margin:0 0 12px;padding:10px 14px;border-radius:12px;background:#F3ECF7;color:#3B303E;font:600 13.5px/1.45 Inter,system-ui,sans-serif;text-align:left';
    /* above the button's row: on the photo kit page the button sits in a flex row, where the note would squeeze in beside it */
    var at = BTN;
    while (at.parentNode && at.parentNode !== form && /flex|grid/.test(getComputedStyle(at.parentNode).display)) at = at.parentNode;
    at.parentNode.insertBefore(NOTE, at);
  }

  function setup() {
    var form = theForm();
    if (!form) return;
    form.setAttribute('data-pk-edit', '1');
    guardDrawer();
    watchAdds();
    keepAddress();
    setQty(form);
    /* keep the old kit's notes (what it was customised from, or any other note) unless the page sets its own, so the
       new version is the same kit with new options */
    var op = props(OLD);
    for (var k in op) {
      if (!Object.prototype.hasOwnProperty.call(op, k) || k === PROP) continue;
      var name = 'properties[' + k + ']';
      var inp = null, all = form.querySelectorAll('input, select, textarea');
      for (var a = 0; a < all.length; a++) if (all[a].name === name) inp = all[a];
      if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = name; form.appendChild(inp); }
      if (!inp.value) inp.value = op[k];
    }
    /* "Add to cart" -> "Update my kit", kept that way when the theme rewrites the button */
    BTN = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    if (BTN) {
      watchLabel();
      makeNote(form);
      say(MODE === 'partial' ? 'partial' : 'edit');
    }
    form.addEventListener('submit', onSubmit, true);
    /* the kit's own frame, size and canvas (see restoreOptions), until the customer changes an option themselves */
    var mark = function (e) {
      if (e.isTrusted && !(e.target && e.target.closest && e.target.closest('[type="submit"],[name="quantity"]'))) touched = true;
    };
    form.addEventListener('click', mark, true);
    form.addEventListener('change', mark, true);
    window.addEventListener('paintly:shape', function () { setTimeout(restoreOptions, 60); });
    restoreOptions();
    /* the kit can be changed in the cart drawer while this page is open (its quantity, or taken out): the cart is read
       again after any change to it made on this page (see watchAdds), when the drawer opens or closes, and when the
       page comes back into view (the cart may have been changed in another tab) */
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      try { new MutationObserver(soonRefresh).observe(cd, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) soonRefresh(); });
  }

  function relabel() {
    if (MODE === 'off' || !BTN) return;
    var w = document.createTreeWalker(BTN, NodeFilter.SHOW_TEXT, null), n, m;
    while ((n = w.nextNode())) {
      if ((m = /add to cart/i.exec(n.nodeValue))) { if (!ADD_LABEL) ADD_LABEL = m[0]; n.nodeValue = n.nodeValue.replace(/add to cart/i, 'Update my kit'); }
      if (/\badded!/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\badded!/i, 'Updated!');
    }
  }
  function watchLabel() {
    relabel();
    if (!BTN || labelingButton === BTN) return;
    labelingButton = BTN;
    try { new MutationObserver(relabel).observe(BTN, { childList: true, subtree: true, characterData: true }); } catch (e) {}
  }
  function unlabel() {
    if (!BTN) return;
    var w = document.createTreeWalker(BTN, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (/update my kit/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/update my kit/i, ADD_LABEL || 'Add to cart');
      if (/\bupdated!/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\bupdated!/i, 'Added!');
    }
  }

  /* the same number of kits as in the cart */
  function setQty(form) {
    if (!form) return;
    var qi = form.querySelector('input[name="quantity"]');
    var fid = form.getAttribute('id');
    if (!qi && fid) qi = document.querySelector('input[name="quantity"][form="' + fid + '"]');
    if (!qi && OLDQTY <= 1) return;
    if (!qi) { qi = madeQty = document.createElement('input'); qi.type = 'hidden'; qi.name = 'quantity'; form.appendChild(qi); }
    else if (QTY0 === null && qi !== madeQty) QTY0 = { el: qi, v: qi.value };
    qi.value = OLDQTY;
  }

  /* the kit was taken out of the cart while this page was open: back to a normal page, and say so */
  function exitEdit() {
    if (OLDSIG) pendingDrop(idOf(OLDSIG));
    MODE = 'off'; OLD = null; OP = null;
    releaseDrawer();
    var form = theForm();
    if (madeQty && madeQty.parentNode) madeQty.parentNode.removeChild(madeQty);
    madeQty = null;
    if (QTY0) { QTY0.el.value = QTY0.v; QTY0 = null; }     /* the page's own quantity, not the old kit's */
    if (form) form.removeAttribute('data-pk-edit');
    unlabel();
    say('gone');
    forgetKit();
    headingNormal();
  }

  function soonRefresh() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refreshOld, 400); }
  /* read the cart again (cart changed on this page, drawer opened or closed, page back in view) */
  function refreshOld() {
    if (drawerHeld || (MODE !== 'idle' && MODE !== 'partial') || !OLD) return;
    getCart().then(function (c) {
      if ((MODE !== 'idle' && MODE !== 'partial') || !OLD) return;
      var ms = linesOf(c, OLDSIG);
      if (MODE === 'partial') {
        if (OP && !OP.newSig) {
          identifyReplacement(OP, c);
          if (!OP.newSig) { if (!ms.length) return exitEdit(); say('partial'); return; }
          pendingSet(idOf(OLDSIG), OP);
        }
        var ns = OP ? linesOf(c, OP.newSig) : [];
        if (!ms.length && ns.length) return done(OP, c, true);            /* they took the old one out themselves */
        if (!ms.length && !ns.length) return exitEdit();
        if (ms.length && !ns.length) {                                     /* they took the new one out: still editing the old */
          pendingDrop(idOf(OLDSIG));
          if (ONNEW) return exitEdit();                                    /* (this page was for the new one) */
          OP = null; MODE = 'idle'; say('edit');
        } else return;                                                     /* both still there: the note already says so */
      }
      if (!ms.length) return exitEdit();
      OLD = ms[0]; KEY = OLD.key; OLDQTY = sumQty(ms) || 1;
      setQty(theForm());
      addressKey();
    }).catch(function () {});
  }

  /* The AI kit forms start on a tall picture and move the size to fit the design once its picture has loaded, which
     would leave the kit on the first size of that shape rather than the one in the cart. So the kit's own options are
     put back each time the shape settles, until the customer changes an option, and only while the kit's size fits
     the design's shape (a new design in another shape keeps the page's own choice). */
  function fitsShape(v) {
    var m = /^(\d+)\s*[x×]\s*(\d+)/i.exec(String(v || '')), s = window.PaintlyAIShape;
    if (!m || !s) return true;
    var w = +m[1], h = +m[2];
    return s === 'square' ? w === h : s === 'wide' ? w > h : w < h;
  }
  function restoreOptions() {
    var form = theForm();
    if (!form || touched || MODE !== 'idle' || !OLD || form.getAttribute('id') !== 'ai-product-form') return;
    var want = OLD.options_with_values || [], changed = false, i, k;
    for (i = 0; i < want.length; i++) if (!fitsShape(want[i].value)) return;
    for (i = 0; i < want.length; i++) {
      var pos = String(i + 1), val = want[i].value;
      var sel = form.querySelector('select.ai-form__select[data-option-position="' + pos + '"]');
      if (sel) {
        if (sel.value !== val) for (k = 0; k < sel.options.length; k++) if (sel.options[k].value === val) { sel.value = val; changed = true; }
        var lab = document.getElementById('ai-selected-' + pos);
        if (lab && sel.value === val) lab.textContent = val;
        continue;
      }
      var cards = form.querySelectorAll('.ai-form__frame-card[data-option-position="' + pos + '"]'), hit = null;
      for (k = 0; k < cards.length; k++) if (cards[k].getAttribute('data-value') === val) hit = cards[k];
      if (hit && !hit.classList.contains('is-active')) {
        for (k = 0; k < cards.length; k++) cards[k].classList.remove('is-active');
        hit.classList.add('is-active');
        changed = true;
      }
    }
    /* one change event runs the form's own checks, the variant and the price, as a customer's change would */
    var carrier = form.querySelector('select.ai-form__select');
    if (changed && carrier) carrier.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* The theme's own add is followed through delayed starts and responses; no timer releases its duplicate guard. */
  var ADD = /\/cart\/add(\.js)?(\?|#|$)/, CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|#|$)/;
  /* the version a form or a request asks for: its variant and notes, as sigOf makes them (null: cannot be read) */
  function wantOf(fd) {
    var v = 0, ps = Object.create(null), m;
    fd.forEach(function (val, k) {
      if (typeof val !== 'string') return;
      if (k === 'id') v = parseInt(val, 10) || v;
      else if ((m = /^properties\[(.+)\]$/.exec(k))) ps[m[1]] = val;
    });
    return v ? sigOf({ variant_id: v, properties: ps }) : null;
  }
  function bodyWant(init) {
    var b = init && init.body;
    if (!b) return null;
    try {
      if (typeof FormData !== 'undefined' && b instanceof FormData) return wantOf(b);
      if (typeof b === 'string') {
        var j = JSON.parse(b), it = (j.items && j.items[0]) || j;
        return it && it.id ? sigOf({ variant_id: parseInt(it.id, 10) || 0, properties: it.properties || {} }) : null;
      }
    } catch (e) {}
    return null;
  }
  function watchAdds() {
    var of = window.fetch;
    if (!of || of.__pkWatch) return;
    var wrapped = function (u, init) {
      var p = of.apply(this, arguments);
      try {
        var url = String((u && u.url) || u || ''), op = OP, ours = false;
        if (init && init.pkOwn) return p;                   /* this script's own removals */
        if (op && !op.seen && ADD.test(url) && (MODE === 'adding' || MODE === 'waiting')) {
          var w = bodyWant(init);
          ours = w !== null && w === op.want;
        }
        if (ours) {
          op.seen = true;
          MODE = 'adding';
          pendingSet(idOf(OLDSIG), op);
          p.then(function (r) {
            if (!r || !r.ok) { op.rejected = !!r && r.status === 422; return addUncertain(op); }
            var c2 = null;
            try { c2 = r.clone(); } catch (e) {}
            if (!c2) return added(op, null);
            c2.json().then(function (j) { added(op, j); }, function () { added(op, null); });
          }, function () { addUncertain(op); });
        } else if (CHANGE.test(url)) {
          p.then(soonRefresh, soonRefresh);
        }
      } catch (e) {}
      return p;
    };
    wrapped.__pkWatch = 1;
    window.fetch = wrapped;
  }

  /* the address keeps the kit (its line and its kit id), so a reload opens it again: the photo kit page rewrites it to
     ?variant=… when an option changes, and after Update my kit the kit is the new version */
  var RS = history.replaceState;
  function keepAddress() {
    if (addressHook) return;
    addressHook = true;
    try {
      history.replaceState = function (st, t, url) {
        try {
          if (url != null && MODE !== 'off') {
            var u = new URL(url, location.href);
            if (u.pathname === location.pathname && !u.searchParams.has('edit')) {
              if (!u.searchParams.has('design') && !u.searchParams.has('remix') && !u.searchParams.has('photo')) u.searchParams.set(AI ? 'design' : 'photo', PIC);
              u.searchParams.set('edit', KEY);
              if (OLD) u.searchParams.set('kit', kitOf(OLD));
              url = u.pathname + u.search + u.hash;
            }
          }
        } catch (e) {}
        return RS.call(history, st, t, url);
      };
    } catch (e) {}
  }
  /* the line and kit id only (the picture and options as the page has them) */
  function addressKey() {
    try {
      var u = new URL(location.href), id = kitOf(OLD);
      if (u.searchParams.get('edit') === KEY && u.searchParams.get('kit') === id) return;
      u.searchParams.set('edit', KEY);
      u.searchParams.set('kit', id);
      RS.call(history, history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  /* everything, after Update my kit: the new version's variant, picture, line and kit id */
  function addressNow() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('design'); u.searchParams.delete('remix'); u.searchParams.delete('photo');
      if (OLD && OLD.variant_id) u.searchParams.set('variant', OLD.variant_id);
      u.searchParams.set(AI ? 'design' : 'photo', PIC);
      u.searchParams.set('edit', KEY);
      u.searchParams.set('kit', kitOf(OLD));
      RS.call(history, history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function field(form, name) {
    var els = form.querySelectorAll('[name="' + name + '"]');
    return els.length ? els[els.length - 1].value : '';
  }
  /* A replacement briefly exists alongside the old kit. Never present that working cart as the result.
     Only the final section read may reopen the drawer; ordinary adds keep the theme's own behavior. */
  function guardDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || cd.__pkEditGuard) return;
    if (typeof cd.open !== 'function' || typeof cd.renderContents !== 'function') {
      if (!drawerWait && window.customElements && !customElements.get('cart-drawer')) {
        drawerWait = true; customElements.whenDefined('cart-drawer').then(guardDrawer);
      }
      return;
    }
    cd.__pkEditGuard = true;
    var open = cd.open, render = cd.renderContents;
    cd.open = function () {
      if (drawerHeld) return;
      if (drawerStale) { location.href = '/cart'; return; }
      return open.apply(this, arguments);
    };
    cd.renderContents = function (data) {
      var html = data && data.sections && data.sections['cart-drawer'];
      if (html && replacedSections.indexOf(html) !== -1) return;
      if (drawerHeld || (drawerStale && !html)) return;
      var wasStale = drawerStale, result;
      if (wasStale) { drawerStale = false; document.documentElement.removeAttribute('data-pk-kit-stale'); }
      try { result = render.apply(this, arguments); }
      catch (e) { if (wasStale) releaseDrawer(true); throw e; }
      if (wasStale) releaseDrawer(false); /* a later ordinary add supplied a fresh section */
      return result;
    };
  }
  function holdDrawer() {
    guardDrawer();
    drawerHeld = true;
    document.documentElement.setAttribute('data-pk-kit-updating', '');
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      cd.setAttribute('aria-busy', 'true');
      if (cd.classList.contains('active') && typeof cd.close === 'function') cd.close();
    }
  }
  function releaseDrawer(stale) {
    drawerHeld = false; if (typeof stale === 'boolean') drawerStale = stale;
    var root = document.documentElement, cd = document.querySelector('cart-drawer');
    root.removeAttribute('data-pk-kit-updating');
    if (drawerStale) root.setAttribute('data-pk-kit-stale', ''); else root.removeAttribute('data-pk-kit-stale');
    if (cd) cd.removeAttribute('aria-busy');
    if (!drawerStale) document.dispatchEvent(new Event('paintly:kit-cart-settled'));
  }
  function partialDrawerNote() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || MODE !== 'partial' || !NOTE) return;
    var oldNote = cd.querySelector('#pk-edit-cart-note'); if (oldNote) oldNote.remove();
    var note = NOTE.cloneNode(true); note.id = 'pk-edit-cart-note';
    note.style.margin = '12px 20px'; note.style.flexShrink = '0';
    var back = document.createElement('button'); back.type = 'button';
    back.textContent = 'Back to update my kit';
    back.style.cssText = 'display:block;margin-top:8px;border:0;padding:8px 0;background:none;color:inherit;font:inherit;text-decoration:underline;cursor:pointer';
    back.addEventListener('click', function () { if (typeof cd.close === 'function') cd.close(); if (BTN) BTN.focus(); });
    note.appendChild(back);
    var header = cd.querySelector('.drawer__header');
    if (header) header.insertAdjacentElement('afterend', note); else cd.insertBefore(note, cd.firstChild);
  }
  function presentCart() {
    holdDrawer();
    return redraw().then(function () {
      releaseDrawer(false); say(MODE === 'partial' ? 'partial' : 'edit'); partialDrawerNote(); openCart(true);
    }, function () {
      /* Do not reveal old or intermediate markup after a failed section read. The real cart remains available. */
      releaseDrawer(true); say(MODE === 'partial' ? 'partial' : 'refresh');
      if (NOTE) {
        var a = document.createElement('a'); a.href = '/cart'; a.textContent = ' View cart';
        NOTE.appendChild(a);
      }
    });
  }
  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); }

  function onSubmit(e) {
    if (MODE === 'off') return;                         /* a normal page now */
    if (drawerHeld && (MODE === 'idle' || MODE === 'partial')) { stop(e); return; }
    if (releaseSubmit) { releaseSubmit = false; return; }
    if (MODE === 'checking' || MODE === 'adding' || MODE === 'removing') { stop(e); return; }
    if (MODE === 'waiting') { stop(e); say('wait'); return; }            /* the last press's add may still come */
    if (MODE === 'partial') {                           /* only the removal is tried again; nothing is added again */
      stop(e);
      MODE = 'removing';
      holdDrawer();
      say('edit');
      removeOld(OP);
      return;
    }
    if (!OLD) return;
    var form = e.currentTarget;
    /* the theme does not send an add from a button it has switched off; then there is no update to follow */
    if (BTN && (BTN.disabled || BTN.getAttribute('aria-disabled') === 'true')) return;
    var v = parseInt(field(form, 'id'), 10) || 0;
    var pic = field(form, 'properties[' + PROP + ']');
    if (!pic || !v) return;                             /* the page's own checks deal with a missing picture or size */
    if (v === OLD.variant_id && pic === picOf(OLD)) {
      /* nothing changed: no second kit, just show the cart */
      stop(e);
      say('edit');
      openCart();
      return;
    }
    var want = null;
    try { want = wantOf(new FormData(form)); } catch (x) {}
    stop(e);
    MODE = 'checking';
    holdDrawer();
    say('loading');
    getCart().then(function (c) {
      var ms = linesOf(c, OLDSIG);
      if (!ms.length) return exitEdit();
      restorePending(c);
      if (MODE === 'partial') { releaseDrawer(); say('partial'); return; }
      OLD = ms[0]; KEY = OLD.key; OLDQTY = sumQty(ms); setQty(form);
      var before = Object.create(null);
      c.items.forEach(function (it) { if (sameProduct(it)) { var s = sigOf(it); before[s] = (before[s] || 0) + it.quantity; } });
      var fd = new FormData(form);
      var op = OP = { v: parseInt(field(form, 'id'), 10), pic: field(form, 'properties[' + PROP + ']'),
        want: wantOf(fd) || '', t: Date.now(), seen: false, newSig: '', newKey: '', olds: ms.map(function (it) { return it.key; }),
        before: before, qty: OLDQTY, acknowledged: false };
      if (op.want === OLDSIG) { OP = null; MODE = 'idle'; releaseDrawer(); say('edit'); openCart(); return; }
      if (!op.want || !pendingSet(idOf(OLDSIG), op)) { OP = null; MODE = 'idle'; releaseDrawer(); say('storage'); return; }
      MODE = 'adding'; say('edit');
      releaseSubmit = true;
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      releaseSubmit = false;
      setTimeout(function () { if (OP === op && !op.seen && MODE === 'adding') { MODE = 'waiting'; say('wait'); } }, 8000);
    }).catch(function () { OP = null; MODE = 'idle'; releaseDrawer(); say('preflight'); });
  }

  function addFailed(op) {
    if (OP !== op) return;
    pendingDrop(idOf(OLDSIG));
    OP = null;
    MODE = 'idle';
    releaseDrawer();
    say('failed');
  }

  /* the add went through; the reply names the line it made (used only if the new version is not found by its notes) */
  function added(op, j) {
    if (OP !== op) return;
    MODE = 'removing';
    op.acknowledged = true;
    var html = j && j.sections && j.sections['cart-drawer'];
    if (html) { replacedSections.push(html); if (replacedSections.length > 4) replacedSections.shift(); }
    op.newKey = j && (j.key || (j.items && j.items[0] && j.items[0].key)) || '';
    pendingSet(idOf(OLDSIG), op);
    removeOld(op);
  }

  function addUncertain(op) {
    if (OP !== op) return;
    MODE = 'removing';
    pendingSet(idOf(OLDSIG), op);
    removeOld(op);
  }

  function identifyReplacement(op, c) {
    if (op.newSig) return;
    function received(sig) {
      var quantity = sumQty(linesOf(c, sig));
      return op.before ? quantity === (op.before[sig] || 0) + op.qty : quantity > 0;
    }
    if (op.want && op.want !== OLDSIG && received(op.want)) op.newSig = op.want;
    else for (var i = 0; op.newKey && i < c.items.length; i++) {
      var sig = sigOf(c.items[i]);
      if (c.items[i].key === op.newKey && sameProduct(c.items[i]) && sig !== OLDSIG && received(sig)) op.newSig = sig;
    }
  }

  function unchangedBaseline(op, c) {
    if (!op.before) return false;
    var current = Object.create(null);
    c.items.forEach(function (it) { if (sameProduct(it)) { var sig = sigOf(it); current[sig] = (current[sig] || 0) + it.quantity; } });
    var keys = Object.keys(op.before);
    return keys.length === Object.keys(current).length && keys.every(function (sig) { return current[sig] === op.before[sig]; });
  }

  /* Find the new version in the cart (by all of its notes: the kit asked for; else the line the add's reply names),
     then take the old kit's lines out, reading the cart again each time (the deal re-keys lines), until none is left.
     The old kit is never taken out while the new one is not found. A refused or failed removal is tried again a few
     times; then the page says both kits are in the cart. */
  function removeOld(op) {
    var fails = 0, rounds = 0;
    function step() {
      getCart().then(function (c) {
        var i, ns, ms, j;
        if (op.rejected && unchangedBaseline(op, c)) return addFailed(op);
        if (!op.newSig) {
          identifyReplacement(op, c);
          if (!op.newSig || op.newSig === OLDSIG) return partial(op, c);
        }
        ns = linesOf(c, op.newSig);
        if (!ns.length) {                               /* the new kit has gone (taken out in the cart): keep the old one */
          pendingDrop(idOf(OLDSIG));
          if (ONNEW) return exitEdit();
          OP = null; MODE = 'idle'; releaseDrawer(); say('edit');
          return;
        }
        ms = linesOf(c, OLDSIG);
        for (j = 0; j < ms.length; j++) if (op.olds.indexOf(ms[j].key) === -1) op.olds.push(ms[j].key);
        if (!ms.length) return done(op, c);
        if (++rounds > 12) return partial(op, c);
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin', pkOwn: 1,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: ms[0].key, quantity: 0 })
        }).then(function (r) {
          if (!r || !r.ok) throw new Error('remove ' + (r && r.status));
          step();
        });
      }).catch(function () {
        if (++fails >= 3) return partial(op, null);
        setTimeout(step, 700 * fails);
      });
    }
    step();
  }

  /* the old kit is confirmed gone: this page now edits the new version */
  function done(op, c, quiet) {
    var ls = linesOf(c, op.newSig);
    pendingDrop(idOf(OLDSIG));
    if (!ls.length) return exitEdit();
    remember(op.olds, ls[0].key, op.newSig, OLDSIG);
    ONNEW = false;
    OLD = ls[0]; OLDSIG = op.newSig; KEY = OLD.key; PIC = picOf(OLD) || op.pic; OLDQTY = sumQty(ls) || 1;
    setQty(theForm());
    addressNow();
    OP = null;
    MODE = 'idle';
    say('edit');
    if (!quiet) presentCart();
  }

  /* the new kit is in the cart but the old one could not be taken out (or the new one could not be told apart): say
     so, show the cart, remember it for a reload, and let Update my kit try the removal again */
  function partial(op, c) {
    MODE = 'partial';
    say('partial');
    pendingSet(idOf(OLDSIG), op);
    var ns = c && op.newSig ? linesOf(c, op.newSig) : [];
    if (ns.length) remember(op.olds, ns[0].key, op.newSig, OLDSIG);
    presentCart();
  }

  /* the theme's own cart refresh on this page draws the cart page into the drawer, so the drawer is redrawn here from
     the store's section rendering (the same markup the theme uses), keeping the drawer element and its open state */
  function redraw() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Cart preview unavailable'); return r.json(); })
      .then(function (s) {
        var cur = document.querySelector('cart-drawer');
        if (!s || !s['cart-drawer'] || !cur) throw new Error('Cart preview missing');
        if (s && s['cart-drawer'] && cur) {
          var d = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
          if (!d) throw new Error('Cart preview invalid');
          if (d) {
            cur.innerHTML = d.innerHTML;
            cur.classList.toggle('is-empty', d.classList.contains('is-empty'));
            var ov = cur.querySelector('#CartDrawer-Overlay');
            if (ov && typeof cur.close === 'function') ov.addEventListener('click', function () { cur.close(); });
          }
        }
        paintBubble(s && s['cart-icon-bubble']);
      });
  }
  function paintBubble(html) {
    var dst = document.getElementById('cart-icon-bubble');
    if (!html || !dst) return;
    var d = new DOMParser().parseFromString(html, 'text/html');
    var src = d.querySelector('.shopify-section') || d.body;
    dst.innerHTML = src.innerHTML;
  }
  function openCart(keepIfOpen) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') {
      if (keepIfOpen && cd.classList.contains('active')) return;
      try { cd.open(); return; } catch (e) {}
    }
    var ic = document.getElementById('cart-icon-bubble');
    if (ic) ic.click(); else location.href = '/cart';
  }
})();
